<div style="position:relative;padding-left:6px">
  <a class="upload-btn {{customCssClasses ? customCssClasses.join(' ') : ''}}"
     [ngClass]="{'disabled': isUploading || disabled}"
     (click)="openFileExplorer($event)">

    <mat-icon *ngIf="showIcon else defaultIcon" class="icon" matTooltip="attachment">
      {{iconName}}
    </mat-icon>
    <ng-template #defaultIcon>
      <mat-icon class="icon" matTooltip="upload">upload</mat-icon>
    </ng-template>

    <ng-container *ngIf="showCustomText else defaultBtnTextBasedOnConfig">
      {{customText}}
    </ng-container>
    <ng-template #defaultBtnTextBasedOnConfig>{{replaceTexts?.selectFileBtn }}</ng-template>

    <i class="fa fa-paperclip" aria-hidden="true"></i>
    <input type="file" id="sel{{id}}" style="display: none" title="Select file"
           [accept]=formatsAllowed [attr.multiple]="multiple ? '' : null"
           [disabled]="disabled"
           (change)="handleFileInput($event)"
           (click)="handleFileInputReset($event)"/>
    <br>
  </a>
  <span class='label label-info' id="upload-file-info{{id}}">{{allowedFiles[0]?.name}}</span>
</div>
